import Actions from 'redux/actions'
import type { CallAPIAction, Status } from 'api/types'
import { FailResponse } from 'api/evisaAPI/dlAPI'
import { CancelEToIContractResponse } from 'api/newDLTransferAPI'

type State = {} & Status

const initialState = {
  isLoading: false,
  success: false,
  fail: false,
}

export default (
  state: State = initialState,
  action: CallAPIAction<
    Actions.CANCEL_E_TO_I_CONTRACT_ASYNC,
    Actions.CANCEL_E_TO_I_CONTRACT_SUCCESS,
    Actions.CANCEL_E_TO_I_CONTRACT_FAIL,
    CancelEToIContractResponse,
    FailResponse
  >,
): State => {
  switch (action.type) {
    case Actions.CANCEL_E_TO_I_CONTRACT_ASYNC:
    case Actions.CANCEL_E_TO_I_CONTRACT_SUCCESS:
    case Actions.CANCEL_E_TO_I_CONTRACT_FAIL: {
      return {
        ...state,
        ...action.status,
      }
    }

    default:
      return state
  }
}
